import React, { useState, useEffect, useContext } from "react";
import { Container, Form, Alert } from "react-bootstrap";
import { toast } from "react-toastify";
import { AuthContext } from "../../Context/AuthContext";
import axios from "axios";
import Preloader from "../../shared/PreLoaders";
import { logActivity } from "../../utils/LogActivity";
import { Authorization } from "../../Context/Authorization";

const AddMember = () => {
  const initialStage = {
    name: "",
    age: "",
    gender: "",
    vfcCode: "",
    fatherOrHusband: "",
    fatherOrHusbandName: "",
    address: "",
    village: "",
    panchayath: "",
    thaluk: "",
    pinCode: "",
    district: "",
    dob: "",
    phone: "",
    aadhar: "",
    rationCard: "",
    bank: "",
    branch: "",
    accountNumber: "",
    ifscCode: "",
    eMail: "",
    community: "",
    work: "",
    educationalQualification: "",
    income: "",
    whatsAppNo: "",
    maritialStatus: "",
    familyMemberDetails: "",
    profilePicture: "",
    signature: "",
  };
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [vfcOptions, setVfcOptions] = useState([]);
  const [formData, setFormData] = useState(initialStage);
  const [submitMessage, setSubmitMessage] = useState("");
  const { userId } = useContext(AuthContext);
  console.log("id", userId);
  const Api = process.env.REACT_APP_API;

  // Validation function
  const validateForm = (formData) => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "VFC name is required";
    if (!formData.age) newErrors.age = "Age is required";
    if (!formData.gender) newErrors.gender = "Gender is required";
    if (!formData.vfcCode) newErrors.vfcCode = "VFC code is required";
    if (!formData.fatherOrHusband)
      newErrors.fatherOrHusband = "Selection is required";
    if (!formData.fatherOrHusbandName)
      newErrors.fatherOrHusbandName = "Name is required";
    if (!formData.address) newErrors.address = "Address is required";
    if (!formData.village) newErrors.village = "Village is required";
    if (!formData.panchayath) newErrors.panchayath = "Panchayath is required";
    if (!formData.thaluk) newErrors.thaluk = "Thaluk is required";
    if (!formData.pinCode) newErrors.pinCode = "Pin code is required";
    if (!formData.district) newErrors.district = "District is required";
    if (!formData.dob) newErrors.dob = "Date of birth is required";
    if (!formData.phone) newErrors.phone = "Phone is required";
    if (!formData.aadhar) newErrors.aadhar = "Aadhar is required";
    return newErrors;
  };

  useEffect(() => {
    setLoading(true);
    const fetchVfcs = async () => {
      try {
        const config = Authorization();
        const response = await axios.get(`${Api}/api/vfcs`, config);
        const data = response.data.vfcs;
        setVfcOptions(data);
      } catch (error) {
        console.log("Error fetching Data", error);
      }
      setLoading(false);
    };
    fetchVfcs();
  }, [Api]);

  const handleChange = (e) => {
    const { name, type, value, files } = e.target;

    if (type === "file") {
      setFormData({
        ...formData,
        [name]: files[0], // Save the selected file for profilePicture or signature
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      toast.error("Please fill all Details");
      setSubmitMessage("Please fill all Details");
      return;
    }

    const formDataToSend = new FormData();

    formDataToSend.append("profilePicture", formData.profilePicture);
    formDataToSend.append("signature", formData.signature);

    for (const key in formData) {
      if (key !== "profilePicture" && key !== "signature") {
        formDataToSend.append(key, formData[key]);
      }
    }

    try {
      const config = Authorization();
      const response = await fetch(`${Api}/api/members`, {
        method: "POST",
        headers: {
          ...config.headers, // Spread headers from Authorization()
        },
        body: formDataToSend,
      });

      if (response.ok) {
        const result = await response.json();
        console.log("Success:", result);
        toast.success("Added Successfully");
        setSubmitMessage("Member Added successfully!");
        await logActivity(userId, "New Member Added", "Add Member Page", Api);
        setFormData(initialStage);
        setErrors("");
      } else {
        console.error("Error submitting form:", response.statusText);
        toast.error("Error submitting form");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Error submitting form");
    }
  };

  return (
    <div>
      <div className="page-header">
        <h3 className="page-title">Add New Members</h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Add New Members
            </li>
          </ol>
        </nav>
      </div>
      <Container className="add-member-container">
        {submitMessage && <Alert variant="info">{submitMessage}</Alert>}
        <Preloader loading={loading} />

        <div className="col-md-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <p className="card-description">New Member Registration Form</p>
              <form className="form-sample" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="name">Name</label>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter Name"
                        value={formData.name}
                        onChange={handleChange}
                        isInvalid={!!errors.name}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.name}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="age">Age</label>
                      <Form.Control
                        type="text"
                        name="age"
                        placeholder="Enter Age"
                        value={formData.age}
                        onChange={handleChange}
                        isInvalid={!!errors.age}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.age}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="vfcName">Select Gender</label>
                      <Form.Control
                        as="select"
                        name="gender"
                        value={formData.gender}
                        onChange={handleChange}
                        isInvalid={!!errors.gender}
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="other">Other</option>
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.gender}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="vfcCode">VFC Code</label>
                      <Form.Control
                        as="select"
                        name="vfcCode"
                        value={formData.vfcCode}
                        onChange={handleChange}
                        isInvalid={!!errors.vfcCode}
                      >
                        <option value="">Select VFC Code</option>
                        {vfcOptions.map((vfc) => (
                          <option key={vfc._id} value={vfc._id}>
                            {vfc.vfcName}
                          </option>
                        ))}
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.vfcCode}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="fatherOrHusband">Father(or)Husband</label>
                      <Form.Control
                        as="select"
                        name="fatherOrHusband"
                        value={formData.fatherOrHusband}
                        onChange={handleChange}
                        isInvalid={!!errors.fatherOrHusband}
                      >
                        <option value="">Select Father/Husband</option>
                        <option value="Father">Father</option>
                        <option value="Husband">Husband</option>
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.fatherOrHusband}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="fatherOrHusbandName">
                        Father Or Husband Name
                      </label>
                      <Form.Control
                        type="text"
                        id="fatherOrHusbandName"
                        name="fatherOrHusbandName"
                        placeholder="Enter VFC Code"
                        value={formData.fatherOrHusbandName}
                        onChange={handleChange}
                        isInvalid={!!errors.fatherOrHusbandName}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.fatherOrHusbandName}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="address">Address</label>
                      <Form.Control
                        type="text"
                        id="address"
                        name="address"
                        placeholder="Enter Address"
                        value={formData.address}
                        onChange={handleChange}
                        isInvalid={!!errors.address}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.address}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="village">Village</label>
                      <Form.Control
                        type="text"
                        id="village"
                        name="village"
                        placeholder="Enter Village"
                        value={formData.village}
                        onChange={handleChange}
                        isInvalid={!!errors.village}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.village}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="panchayath">Panchayath</label>
                      <Form.Control
                        type="text"
                        id="panchayath"
                        name="panchayath"
                        placeholder="Enter Panchayath"
                        value={formData.panchayath}
                        onChange={handleChange}
                        isInvalid={!!errors.panchayath}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.panchayath}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="thaluk">Thaluk</label>
                      <Form.Control
                        type="text"
                        id="thaluk"
                        name="thaluk"
                        placeholder="Enter Thaluk"
                        value={formData.thaluk}
                        onChange={handleChange}
                        isInvalid={!!errors.thaluk}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.thaluk}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="pinCode">PinCode</label>
                      <Form.Control
                        type="text"
                        id="pinCode"
                        name="pinCode"
                        placeholder="Enter PinCode"
                        value={formData.pinCode}
                        onChange={handleChange}
                        isInvalid={!!errors.pinCode}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.pinCode}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="district">District</label>
                      <Form.Control
                        type="text"
                        id="district"
                        name="district"
                        placeholder="Enter District"
                        value={formData.district}
                        onChange={handleChange}
                        isInvalid={!!errors.district}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.district}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="dob">Date of Birth</label>
                      <Form.Control
                        type="date"
                        name="dob"
                        placeholder="Enter Date of Birth"
                        value={formData.dob}
                        onChange={handleChange}
                        isInvalid={!!errors.dob}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.dob}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="phone">Phone</label>
                      <Form.Control
                        type="text"
                        id="phone"
                        name="phone"
                        placeholder="Enter Phone"
                        value={formData.phone}
                        onChange={handleChange}
                        isInvalid={!!errors.phone}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.phone}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="aadhar">Aadhar Number</label>
                      <Form.Control
                        type="text"
                        id="aadhar"
                        name="aadhar"
                        placeholder="Enter Aadhar Number"
                        value={formData.aadhar}
                        onChange={handleChange}
                        isInvalid={!!errors.aadhar}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.aadhar}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="rationCard">Ration Card Number</label>
                      <Form.Control
                        type="text"
                        id="rationCard"
                        name="rationCard"
                        placeholder="Enter Ration Card Number"
                        value={formData.rationCard}
                        onChange={handleChange}
                        isInvalid={!!errors.rationCard}
                      />
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="bank">Bank Name</label>
                      <Form.Control
                        type="text"
                        id="bank"
                        name="bank"
                        placeholder="Enter Bank Name"
                        value={formData.bank}
                        onChange={handleChange}
                        isInvalid={!!errors.bank}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="branch">Branch Name</label>
                      <Form.Control
                        type="text"
                        id="branch"
                        name="branch"
                        placeholder="Enter Branch Name"
                        value={formData.branch}
                        onChange={handleChange}
                        isInvalid={!!errors.branch}
                      />
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="accountNumber">Account Number</label>
                      <Form.Control
                        type="text"
                        id="accountNumber"
                        name="accountNumber"
                        placeholder="Enter AccountNumber"
                        value={formData.accountNumber}
                        onChange={handleChange}
                        isInvalid={!!errors.accountNumber}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="ifscCode">IFSC Code</label>
                      <Form.Control
                        type="text"
                        id="ifscCode"
                        name="ifscCode"
                        placeholder="Enter IFSC Code"
                        value={formData.ifscCode}
                        onChange={handleChange}
                        isInvalid={!!errors.ifscCode}
                      />
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="eMail">E-Mail</label>
                      <Form.Control
                        type="text"
                        id="eMail"
                        name="eMail"
                        placeholder="Enter E-Mail"
                        value={formData.eMail}
                        onChange={handleChange}
                        isInvalid={!!errors.eMail}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="community">Community</label>
                      <Form.Control
                        type="text"
                        id="community"
                        name="community"
                        placeholder="Enter Community"
                        value={formData.community}
                        onChange={handleChange}
                        isInvalid={!!errors.community}
                      />
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="work">Occupation</label>
                      <Form.Control
                        type="text"
                        id="work"
                        name="work"
                        placeholder="Enter Occupation"
                        value={formData.work}
                        onChange={handleChange}
                        isInvalid={!!errors.work}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="educationalQualification">
                        Educational Qualification
                      </label>
                      <Form.Control
                        type="text"
                        id="educationalQualification"
                        name="educationalQualification"
                        placeholder="Enter Educational Qualification"
                        value={formData.educationalQualification}
                        onChange={handleChange}
                        isInvalid={!!errors.educationalQualification}
                      />
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="income">Income</label>
                      <Form.Control
                        type="text"
                        id="income"
                        placeholder="Enter Income"
                        name="income"
                        value={formData.income}
                        onChange={handleChange}
                        isInvalid={!!errors.income}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="whatsAppNo">WhatsAppNo</label>
                      <Form.Control
                        type="text"
                        name="whatsAppNo"
                        id="whatsAppNo"
                        placeholder="Enter WhatsAppNo"
                        value={formData.whatsAppNo}
                        onChange={handleChange}
                        isInvalid={!!errors.whatsAppNo}
                      />
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="maritialStatus">Maritial Status</label>
                      <Form.Control
                        type="text"
                        id="maritialStatus"
                        name="maritialStatus"
                        placeholder="Enter Maritial Status"
                        value={formData.maritialStatus}
                        onChange={handleChange}
                        isInvalid={!!errors.maritialStatus}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="familyMemberDetails">
                        Family Member Details
                      </label>
                      <Form.Control
                        type="text"
                        id="familyMemberDetails"
                        name="familyMemberDetails"
                        placeholder="Enter Family Member Details"
                        value={formData.familyMemberDetails}
                        onChange={handleChange}
                        isInvalid={!!errors.familyMemberDetails}
                      />
                    </Form.Group>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="profilePicture">Profile Picture</label>
                      <Form.Control
                        type="file"
                        name="profilePicture"
                        onChange={handleChange}
                        isInvalid={!!errors.profilePicture}
                      />
                    </Form.Group>
                  </div>
                  <div className="col-md-6">
                    <Form.Group>
                      <label htmlFor="signature">Sighnature</label>
                      <Form.Control
                        type="file"
                        name="signature"
                        onChange={handleChange}
                        isInvalid={!!errors.signature}
                      />
                    </Form.Group>
                  </div>
                </div>

                <button
                  type="submit"
                  className="btn btn-outline-primary btn-icon-text mt-3"
                >
                  <i className="mdi mdi-file-check btn-icon-prepend"></i>
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default AddMember;
